import { UserLanguagesResponse } from 'src/api/me/types';

export const getLanguagePair = (
  userLanguagesData: UserLanguagesResponse | undefined,
  languagePairIdFilter: number | undefined,
) => {
  const languagePair = userLanguagesData?.languagePairs?.find(
    el => el.languagePairId === languagePairIdFilter,
  );

  return languagePair || userLanguagesData?.languagePairs[0];
};
